<div fxLayout="row" fxLayoutAlign="start center" class="ratings" [matTooltip]="ratingsCount + ' ratings'" matTooltipPosition="above">        
  <mat-icon *ngFor="let star of stars;" class="mat-icon-sm">{{star}}</mat-icon>
</div> 